//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
import * as QuizActions from './actions';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create quiz --------------------


//  -- List chapter quizzes --------
export const handleListChapterQuizzes = (chapterID) => async (dispatch) => {
    await dispatch(QuizActions.listChapterQuizzes());

    try {
        let quizzes = []
        const quizzesRDS = await apis.get('quizzesRDS', `/quizzesByChapter/${chapterID}`);
        if (Array.isArray(quizzesRDS) && quizzesRDS.length > 0) {
            quizzes = quizzesRDS
        }
        await dispatch(QuizActions.listChapterQuizzesSuccess(quizzes));
        return quizzes;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing chapter quizzes',
                error,
                module: 'QUIZZES',
                operation: 'LIST_CLASS_QUIZ'
            });
        }
        await dispatch(QuizActions.listChapterQuizzesFail(error));
    }
};

//  -- List quizzes ----------------
export const handleListQuizzes = () => async(dispatch) => {
    return;
    await dispatch(QuizActions.listQuizzes());

    try {
        let  quizzes = []
        const quizzesRDS = await apis.get('quizzesRDS', `/quizzes`);
        if(Array.isArray(quizzesRDS)&& quizzesRDS.length>0){
            quizzes = quizzesRDS
        }
        await dispatch(QuizActions.listQuizzesSuccess(quizzes));
        return quizzes;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing quizzes',
                error,
                module: 'QUIZZES',
                operation: 'LIST_QUIZ'
            });
         }
        await dispatch(QuizActions.listQuizzesFail(error));
    }
};

export const handleCreateQuizzes = (quiz) => async (dispatch) => {
    dispatch(QuizActions.createQuiz())
    try {
        const quizzesRDS = await apis.post('quizzesRDS', `/create`, {
            body: quiz
        });
        if (has(quizzesRDS, "id")) {
            await dispatch(QuizActions.createQuizSuccess(quizzesRDS))
        } else {
            await dispatch(QuizActions.createQuizFail(quizzesRDS))
        }
    } catch (error) {
        console.log(error, "error in create quizzes");
    }
}
export const handleUpdateQuizzes = (id,quiz) => async (dispatch) => {
    dispatch(QuizActions.updateQuiz())
    try {
        const quizzesRDS = await apis.put('quizzesRDS', `/update/${id}`, {
            body: quiz
        });
        if (has(quizzesRDS, "id")) {
            await dispatch(QuizActions.updateQuizSuccess(quizzesRDS))
        } else {
            await dispatch(QuizActions.updateQuizFail(quizzesRDS))
        }
    } catch (error) {
        console.log(error, "error in update quizzes");
    }
}


export const handleAdminDeleteQuizzes = (id) => async (dispatch) => {
    dispatch(QuizActions.deleteQuiz())
    try {
        const quizzesRDS = await apis.post('quizzesRDS', `/AdminQuizDelete`, {
            body: {
                "id": id,
            }
        });
        if (has(quizzesRDS, "id")) {
            await dispatch(QuizActions.deleteQuizSuccess(quizzesRDS))
        }
       
    } catch (error) {
        console.log(error, "error in update quizzes");
    }
}

export const handleListQuizzesByIds = (ids) => async (dispatch) => {
    try {
        const quizzes = await apis.post('quizzesRDS', `/list_admin_quizzes_by_books`, {
            body: {
                ids
            }
        });
        return quizzes;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing quizzes by ids',
                error,
                module: 'QUIZZES',
                operation: 'LIST_QUIZ_BOOK_INSTRUCTION'
            })
        }
        return [];
    }
}

export const handleListAssignedQuizzesByIds = (ids, classId) => async (dispatch) => {
    try {
        const quizzes = await apis.post('quizzesRDS', `/list_assigned_quizzes_admin`, {
            body: {
                ids,
                classId
            }
        });
        return quizzes;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'Error listing assigned quizzes by ids',
                error,
                module: 'QUIZZES',
                operation: 'LIST_ASSIGNED_QUIZZES_BY_IDS'
            })
        }
        return [];
    }
}

export const handleListResourseQuizzes = () => async (dispatch) => {
    try {
        const quizzes = await apis.get('quizzesRDS', `/list_admin_quizzes_by_resourse`);
        return quizzes;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing resourse quizzes',
                error,
                module: 'QUIZZES',
                operation: 'L_R_Q'
            })
        }
        return [];
    }
}